// These three types mirror the generated OpenAPI client's Model_ConfigurationQueryFilterPost and friends
// (Model_ConfigurationQueryAttributeFilterPost / Model_ConfigurationQueryAttributValueFilterPost) field-for-field,
// but are defined locally rather than imported so the Filter panel's form state isn't coupled to the generated
// client's optional/required shape while a filter is still being edited.
export type TAttributeValueFilter = { id?: string; description?: string };
export type TAttributeFilter = { id?: string; name?: string; values?: TAttributeValueFilter[] };
export type TAttributeQueryFilter = { attributes?: TAttributeFilter[] };

export type TAttributeOptionsType = TAttributeValueFilter;

export type TAppliedFilterChip = {
  attributeId?: string;
  attributeName?: string;
  customFilterId?: string;
  valueId: string;
  valueDescription: string;
};

type TCustomFilterGroup = { filters: { id: string; description: string }[]; name: string };

export type TCustomFilter = { id: string; description: string; filterType: "missingInfo" | "invalidInfo" | "productType" | "configurationName" | "label" };

// sentinel id for the "no labels" option in the label filter; matches the "unlabelled" bucket key
// already used by the group-by-label feature (see configurations-list-utils.ts / products-utils.ts)
export const NO_LABEL_FILTER_ID = "unlabelled";

export const getAllFilters = (formData: TAttributeQueryFilter, customFilterGroups?: TCustomFilterGroup[]): TAppliedFilterChip[] => {
  const finalOutput: TAppliedFilterChip[] = [];
  if (formData.attributes) {
    const result = formData.attributes?.reduce((acc, attribute) => {
      attribute.values?.forEach(attributeValue => {
        if (attribute.id && attribute.name && attributeValue.id && attributeValue.description) {
          acc.push({
            attributeId: attribute.id,
            attributeName: attribute.name,
            valueId: attributeValue.id,
            valueDescription: attributeValue.description
          });
        }
      });
      return acc;
    }, [] as TAppliedFilterChip[]);
    finalOutput.push(...result);
  }
  if (customFilterGroups) {
    customFilterGroups.forEach(group => {
      finalOutput.push(
        ...group.filters.map(filter => ({
          customFilterId: filter.id,
          valueId: filter.id,
          valueDescription: `${group.name} - ${filter.description}`
        }))
      );
    });
  }
  return finalOutput;
};

// Shared by Filter's own header and the options rail's collapsed label
export const getTotalFiltersApplied = (formData: TAttributeQueryFilter, appliedCustomFilters: TCustomFilter[]): number => getAllFilters(formData).length + appliedCustomFilters.length;

// Whether the filter still narrows the SERVER query. Counts values, not attributes: removing an
// applied-filter chip empties an attribute's values but leaves the attribute entry in place, so
// attributes.length alone would report a filter that no longer excludes anything.
export const hasAttributeFilter = (filter: TAttributeQueryFilter): boolean => (filter.attributes ?? []).some(attribute => (attribute.values ?? []).length > 0);
